import { Link } from 'react-router-dom';
import { useInView } from '@/hooks/useInView';

export default function CTASection() {
  const { ref, inView } = useInView();

  const anim = (inView: boolean) =>
    `transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`;

  return (
    <section className="relative w-full min-h-[100svh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Panoramic%20mountain%20range%20viewed%20from%20above%20at%20dusk%2C%20layers%20of%20dark%20blue%20silhouettes%20with%20mist%2C%20wide%20aerial%20perspective%2C%20atmospheric%20and%20contemplative%20mood%2C%20fine%20art%20landscape%20photography%2C%20subtle%20golden%20light%20on%20horizon%2C%20serene%20vastness&width=1920&height=800&seq=cta-mountain-002&orientation=landscape"
          alt="山頂視角 PeakView — 暮色山脈全景"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-primary-950/75"></div>

      <div ref={ref} className={`relative z-10 w-full px-6 md:px-10 ${anim(inView)}`}>
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-4">
            從山頂視角，找到下一本值得閱讀的書
          </h2>
          <p className="text-base text-white/70 leading-relaxed mb-8">
            瀏覽出版書籍、查詢完整書目，並選擇合作購書通路。
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <Link
              to="/stores"
              className="px-6 py-3 bg-white text-primary-950 font-label font-semibold text-sm rounded-full hover:bg-accent-100 transition-all duration-300 whitespace-nowrap"
            >
              查看合作購書通路
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white font-label font-medium text-base rounded-full hover:bg-white/25 border border-white/25 transition-all duration-300 whitespace-nowrap"
            >
              認識山頂視角
            </Link>
            <a
              href="https://sonbook.net/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-6 py-3 bg-foreground-950/25 text-white font-label font-medium text-base rounded-full hover:bg-foreground-950/40 border border-white/15 transition-all duration-300 whitespace-nowrap"
            >
              查詢完整書目
            </a>
          </div>

          <div className="border-t border-white/10 pt-10 max-w-xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-white mb-3">
              品牌經銷與合作洽詢
            </h2>
            <p className="text-base text-white/60 leading-relaxed mb-3">
              如有品牌經銷或合作需求，請直接聯繫洽詢。
            </p>
            <p className="text-base text-white/40">
              品牌經銷與合作方案詳情請直接聯繫洽詢。
            </p>
          </div>

          <p className="text-base text-white/35 mt-10 max-w-xl mx-auto leading-relaxed">
            山頂視角 PeakView 為崧博出版合作經銷品牌，完整書目以崧博出版書籍資料庫為準。
          </p>
        </div>
      </div>
    </section>
  );
}